import { Box, ChipProps, Chip as MUIChip, styled, Typography, useTheme } from '@mui/material'
import { MUIThemeColors } from 'src/mui-theme'
import { Padding } from 'src/styles/paddingComponent'
import { getThemeColor } from 'src/utils'

export const Chip = styled(MUIChip)`
  border-radius: 4px;
`
export interface CountChipProps extends ChipProps {
  count: number
}

export const CountChip: React.FC<CountChipProps> = ({ count, ...rest }) => {
  const theme = useTheme()
  return (
    <Chip
      {...rest}
      deleteIcon={
        <Padding.pl2>
          <Box
            height={'20px'}
            paddingX={'10px'}
            borderRadius={'4px'}
            bgcolor={getThemeColor(theme, MUIThemeColors.primaryMain)}
          >
            <Typography color={getThemeColor(theme, MUIThemeColors.white)} textAlign="center">
              {count}
            </Typography>
          </Box>
        </Padding.pl2>
      }
      onDelete={() => {}}
    />
  )
}
